// utils/StatusColor.js

const statusColorScheme = {
    "Pending": "yellow",
    "In Progress": "blue", 
    "Completed": "green",
    "Failed": "red",

    // Vehicle-specific statuses
    "Approved": "green",
    "Delivered": "green",
    "Completed": "green",
    "Suspended": "red",
    "Rejected": "orange",
    "Deactivated": "purple",
    "Active": "blue",
    "Under Review": "orange",
    "Inactive": "gray",
  
  };
    
  
    const getStatusColor = (status) => {
      return statusColorScheme[status] || "gray";
    };
    
    export default getStatusColor;
    